export default {
  studentTrigger: 'Disparador',
  statement: 'Consigna',
  copyLink: 'Copiar Enlace',
  shareClass: 'Compartir clase',
  resourceObjective: 'Objetivos pedagógicos',
  onlineContent: 'Contenido descargable',
  necessaryMaterial: 'Vas a necesitar',
  electronicMaterial: 'Material electrónico',
  physicalMaterial: 'Útiles escolares',
  resourceTrigger: 'Disparador del recurso',
  download: 'Descargar',
  downloadAll: 'Descargar todo',
  materials: 'Materiales',
  rhetoricalQuestion: 'Pregunta disparadora',
  devices: 'Dispositivos'
}

export const en = {
  studentTrigger: 'Trigger',
  statement: 'Assignment',
  copyLink: 'Copy link',
  shareClass: 'Share class',
  resourceObjective: 'Resource objectives',
  onlineContent: 'Downloadable content',
  necessaryMaterial: 'You\'ll need',
  electronicMaterial: 'Electronic material',
  physicalMaterial: 'School supplies',
  resourceTrigger: 'Resource trigger',
  download: 'Download',
  downloadAll: 'Download all',
  materials: 'Materials',
  rhetoricalQuestion: 'Triggering question',
  devices: 'Devices'
}

export const ca = {
  studentTrigger: 'Disparador',
  statement: 'Consigna',
  copyLink: 'Copia Enllaç',
  shareClass: 'Comparteix classe',
  resourceObjective: 'Objectiu del recurs',
  onlineContent: 'Contingut descarregable',
  necessaryMaterial: 'Necessitaràs',
  electronicMaterial: 'Material electrònic',
  physicalMaterial: 'Material escolar',
  resourceTrigger: 'Disparador del recurs',
  download: 'Descarrega',
  downloadAll: 'Descarrega-ho tot',
  materials: 'Materials',
  rhetoricalQuestion: 'Pregunta disparadora',
  devices: 'Dispositius'
}
